// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eI27","name":"styles_name__14-Tu","phone":"styles_phone__2bn9R"};